export function isClickOnPOIHelper(features: any[]): boolean {
  if (features.length > 0) {
    let feature = features[0]
    if (feature.source !== "hover-point" && feature.source.includes('poi')) {
      return true
    }
  }
  return  false
}
